var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixEventsV1Form from '@wix/ambassador-events-v1-form/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var InputControlType;
(function (InputControlType) {
    /** Single text value field. */
    InputControlType["INPUT"] = "INPUT";
    /** Single text value field. */
    InputControlType["TEXTAREA"] = "TEXTAREA";
    /** Single-choice field of predefined values. */
    InputControlType["DROPDOWN"] = "DROPDOWN";
    /** Single-choice field of predefined values. */
    InputControlType["RADIO"] = "RADIO";
    /** Multiple-choice field of predefined values. */
    InputControlType["CHECKBOX"] = "CHECKBOX";
    /** First and last name fields. */
    InputControlType["NAME"] = "NAME";
    /** Additional guests and respective guest names fields. */
    InputControlType["GUEST_CONTROL"] = "GUEST_CONTROL";
    /** Single-line address field. */
    InputControlType["ADDRESS_SHORT"] = "ADDRESS_SHORT";
    /** Full address field. */
    InputControlType["ADDRESS_FULL"] = "ADDRESS_FULL";
    /** Year, month and day fields. */
    InputControlType["DATE"] = "DATE";
})(InputControlType || (InputControlType = {}));
export var ValueType;
(function (ValueType) {
    ValueType["TEXT"] = "TEXT";
    ValueType["NUMBER"] = "NUMBER";
    ValueType["TEXT_ARRAY"] = "TEXT_ARRAY";
    ValueType["DATE_TIME"] = "DATE_TIME";
    ValueType["ADDRESS"] = "ADDRESS";
})(ValueType || (ValueType = {}));
export var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** Include soft deleted input controls in the response. */
    RequestedFields["DELETED"] = "DELETED";
})(RequestedFields || (RequestedFields = {}));
export var LocationType;
(function (LocationType) {
    LocationType["VENUE"] = "VENUE";
    LocationType["ONLINE"] = "ONLINE";
})(LocationType || (LocationType = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var Status;
(function (Status) {
    /** Event occurs only once. */
    Status["ONE_TIME"] = "ONE_TIME";
    /** Event is recurring. */
    Status["RECURRING"] = "RECURRING";
    /** Marks the next upcoming occurrence of the recurring event. */
    Status["RECURRING_NEXT"] = "RECURRING_NEXT";
    /** Marks the most recent ended occurrence of the recurring event. */
    Status["RECURRING_LAST_ENDED"] = "RECURRING_LAST_ENDED";
    /** Marks the most recent canceled occurrence of the recurring event. */
    Status["RECURRING_LAST_CANCELED"] = "RECURRING_LAST_CANCELED";
})(Status || (Status = {}));
export var EventStatus;
(function (EventStatus) {
    /** Event is public and scheduled to start */
    EventStatus["SCHEDULED"] = "SCHEDULED";
    /** Event has started */
    EventStatus["STARTED"] = "STARTED";
    /** Event has ended */
    EventStatus["ENDED"] = "ENDED";
    /** Event was canceled */
    EventStatus["CANCELED"] = "CANCELED";
    /** Event is not public and needs to be published */
    EventStatus["DRAFT"] = "DRAFT";
})(EventStatus || (EventStatus = {}));
export var EventType;
(function (EventType) {
    /** Type not available for this request fieldset */
    EventType["NA_EVENT_TYPE"] = "NA_EVENT_TYPE";
    /** Registration via RSVP */
    EventType["RSVP"] = "RSVP";
    /** Registration via ticket purchase */
    EventType["TICKETS"] = "TICKETS";
    /** External registration */
    EventType["EXTERNAL"] = "EXTERNAL";
    /** Registration not available */
    EventType["NO_REGISTRATION"] = "NO_REGISTRATION";
})(EventType || (EventType = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    /** Registration status is not applicable */
    RegistrationStatus["NA_REGISTRATION_STATUS"] = "NA_REGISTRATION_STATUS";
    /** Registration to event is closed */
    RegistrationStatus["CLOSED"] = "CLOSED";
    /** Registration to event is closed manually */
    RegistrationStatus["CLOSED_MANUALLY"] = "CLOSED_MANUALLY";
    /** Registration is open via RSVP */
    RegistrationStatus["OPEN_RSVP"] = "OPEN_RSVP";
    /** Registration to event waitlist is open via RSVP */
    RegistrationStatus["OPEN_RSVP_WAITLIST"] = "OPEN_RSVP_WAITLIST";
    /** Registration is open via ticket purchase */
    RegistrationStatus["OPEN_TICKETS"] = "OPEN_TICKETS";
    /** Registration is open via external URL */
    RegistrationStatus["OPEN_EXTERNAL"] = "OPEN_EXTERNAL";
    /** Registration will be open via RSVP */
    RegistrationStatus["SCHEDULED_RSVP"] = "SCHEDULED_RSVP";
})(RegistrationStatus || (RegistrationStatus = {}));
export var RsvpStatusOptions;
(function (RsvpStatusOptions) {
    /** Only YES RSVP status is available for RSVP registration */
    RsvpStatusOptions["YES_ONLY"] = "YES_ONLY";
    /** YES and NO RSVP status options are available for the registration */
    RsvpStatusOptions["YES_AND_NO"] = "YES_AND_NO";
})(RsvpStatusOptions || (RsvpStatusOptions = {}));
export var TaxType;
(function (TaxType) {
    /** Tax is included in the ticket price */
    TaxType["INCLUDED"] = "INCLUDED";
    /** Tax is added to the order at the checkout */
    TaxType["ADDED"] = "ADDED";
    /** Tax is added to the final total at the checkout */
    TaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(TaxType || (TaxType = {}));
export var VisitorType;
(function (VisitorType) {
    /** Site visitor (including member) */
    VisitorType["VISITOR"] = "VISITOR";
    /** Site member */
    VisitorType["MEMBER"] = "MEMBER";
    /** Site visitor or member */
    VisitorType["VISITOR_OR_MEMBER"] = "VISITOR_OR_MEMBER";
})(VisitorType || (VisitorType = {}));
export var ConferenceType;
(function (ConferenceType) {
    /** Everyone in the meeting can publish and subscribe video and audio. */
    ConferenceType["MEETING"] = "MEETING";
    /** Guests can only subscribe to video and audio. */
    ConferenceType["WEBINAR"] = "WEBINAR";
})(ConferenceType || (ConferenceType = {}));
export var State;
(function (State) {
    /** Created manually by the user. */
    State["MANUAL"] = "MANUAL";
    /** Created automatically. */
    State["AUTO"] = "AUTO";
    /** Created when publishing recurring events. */
    State["RECURRING_EVENT"] = "RECURRING_EVENT";
    /** Category is hidden. */
    State["HIDDEN"] = "HIDDEN";
    /** Category is used to store component events. */
    State["COMPONENT"] = "COMPONENT";
})(State || (State = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _addControlRequest = {};
const _addControlResponse = {};
const _deleteControlRequest = {};
const _deleteControlResponse = {};
const _discardDraftRequest = {};
const _discardDraftResponse = {};
const _getFormRequest = {};
const _getFormResponse = {};
const _publishDraftRequest = {};
const _publishDraftResponse = {};
const _updateControlRequest = {};
const _updateControlResponse = {};
const _updateMessagesRequest = {};
const _updateMessagesResponse = {};
/**
 * Retrieves an event registration form (both the draft and published versions).
 * @public
 * @requiredField eventId
 * @param eventId - Event ID to which the form belongs.
 * @param options - Optional fields.
 * @returns Currently published event form.
 * Published form is visible to site visitors.
 */
export function getForm(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { eventId: '$[0]', fields: '$[1].fields' };
        const responseTransformation = '$.form';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getFormRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getFormResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['form', 'draftForm']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Form.getForm(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Adds an input control to the draft form.
 * @public
 * @requiredField eventId
 * @param eventId - Event ID to which the form belongs.
 * @param options - Optional fields.
 * @adminMethod
 */
export function addControl(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            phone: '$[1].phone',
            address: '$[1].address',
            date: '$[1].date',
            additionalGuests: '$[1].additionalGuests',
            dropdown: '$[1].dropdown',
            radio: '$[1].radio',
            checkbox: '$[1].checkbox',
            text: '$[1].text',
            radioButton: '$[1].radioButton',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _addControlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _addControlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['form']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Form.addControl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates an existing input control in the draft form.
 * @public
 * @requiredField identifiers
 * @requiredField identifiers.eventId
 * @requiredField identifiers.id
 * @param options - Optional fields.
 * @param identifiers - Identifies what form to update.
 * @adminMethod
 */
export function updateControl(identifiers, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0].eventId',
            id: '$[0]._id',
            orderIndex: '$[1].orderIndex',
            phone: '$[1].phone',
            address: '$[1].address',
            date: '$[1].date',
            additionalGuests: '$[1].additionalGuests',
            dropdown: '$[1].dropdown',
            radio: '$[1].radio',
            checkbox: '$[1].checkbox',
            text: '$[1].text',
            name: '$[1].name',
            email: '$[1].email',
            radioButton: '$[1].radioButton',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateControlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateControlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['form']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers, options]);
        const reqOpts = ambassadorWixEventsV1Form.updateControl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes an input control from the draft form.
 * @public
 * @requiredField identifiers
 * @requiredField identifiers.eventId
 * @requiredField identifiers.id
 * @param identifiers - Identifies what form to delete.
 * @adminMethod
 */
export function deleteControl(identifiers) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { eventId: '$[0].eventId', id: '$[0]._id' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteControlRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteControlResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['form']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers]);
        const reqOpts = ambassadorWixEventsV1Form.deleteControl(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates draft form messages, as displayed in the Wix UI before, during, and after the registration flow.
 * Configurable messages include form titles, response labels, "thank you" messages, and call-to-action texts.
 * @public
 * @requiredField eventId
 * @param eventId - Event ID to which the form belongs.
 * @param options - Optional fields.
 * @adminMethod
 */
export function updateMessages(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            fields: '$[1].fields',
            messages: '$[1].messages',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateMessagesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateMessagesResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['form']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV1Form.updateMessages(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Publishes the draft form.
 * @public
 * @requiredField eventId
 * @param eventId - Event ID to which the form belongs.
 * @adminMethod
 */
export function publishDraft(eventId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { eventId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _publishDraftRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _publishDraftResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['form']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId]);
        const reqOpts = ambassadorWixEventsV1Form.publishDraft(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Clears all changes to the draft form.
 * @public
 * @requiredField eventId
 * @param eventId - Event ID to which the form belongs.
 * @adminMethod
 */
export function discardDraft(eventId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { eventId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _discardDraftRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _discardDraftResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId]);
        const reqOpts = ambassadorWixEventsV1Form.discardDraft(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=events-v1-form.universal.js.map